<template>
  <div
    class=""
    v-bind:class="{
      'bg-secondary section-with-bg': hasBackground,
      'section-logos': hasInnerBackground,
    }"
  >
    <div class="container">
      <b-row>
        <b-col
          md="12"
          class="pl-0 py-1 d-flex justify-content-between align-items-center"
        >
          <div class="section-slider-head">
            <h2 v-if="onlyTitle" class="best-picks bestpicks-h2">
              {{ title || $t("productStore.bestPicks") }}
            </h2>
            <h3 class="heading" v-if="showTitle">
              <router-link button to="/" v-if="showBackArrow">
                <b-icon
                  icon="arrow-left-short"
                  variant="black"
                  scale="1.5"
                  class="mr-2"
                ></b-icon> </router-link
              >{{ subTitle }}
            </h3>
          </div>
          <div v-if="!loading && list.length === 0" class="text-center no-item">
            {{ $t("productStore.noItmes") }}
          </div>
          <router-link
            :style="{
              border:
                this.theme &&
                this.theme.primarycolor &&
                this.theme.primarycolor.color,
            }"
            class="view-more-button"
            :to="viewMorePage"
          >
            <button
              :style="{
                color:
                  this.theme &&
                  this.theme.primarycolor &&
                  this.theme.primarycolor.gradientColors[0].color,
                backgroundColor:
                  this.theme &&
                  this.theme.primarycolor &&
                  this.theme.primarycolor.color,
              }"
              class="view-more-text"
              v-if="hasButton"
            >
              View more <b-icon-arrow-right />
            </button>
          </router-link>
        </b-col>
      </b-row>

      <v-slide-group v-if="withSlider" ref="slideGroup" show-arrows="always">
        <template v-if="loading">
          <v-slide-item v-for="n in maxItems" :key="'skeleton-slide-' + n">
            <b-skeleton type="card" width="200px" height="250px" class="mr-2" />
          </v-slide-item>
        </template>
        <template v-else>
          <v-slide-item v-for="(data, i) in list" :key="i">
            <slot :listItem="data"></slot>
          </v-slide-item>
        </template>
      </v-slide-group>

      <v-slide-item v-if="withoutSlider">
        <b-row v-if="loading">
          <b-col
            v-for="n in maxItems"
            :key="'skeleton-' + n"
            md="3"
            sm="6"
            xs="12"
            class="slideItem"
          >
            <b-skeleton
              width="100%"
              height="200px"
              animation="wave"
              class="mb-3"
            />
          </b-col>
        </b-row>

        <!-- Without slider view -->
        <b-row v-else-if="!loading && list.length">
          <b-col
            md="3"
            sm="6"
            xs="12"
            v-for="(data, i) in list.slice(0, maxItems)"
            :key="i"
            class="slideItem"
          >
            <slot :listItem="data" />
          </b-col>
        </b-row>
        <div v-else class="text-center no-item">
          {{ $t("productStore.noItmes") }}
        </div>
      </v-slide-item>
    </div>
  </div>
</template>

<script>
export default {
  updated() {
    if (this.withSlider) {
      this.$refs.slideGroup.setWidths();
    }
  },
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Best Picks",
    },
    onlyTitle: {
      type: Boolean,
      default: false,
    },
    subTitle: {
      type: String,
      // default: "Default Title",
    },
    viewMorePage: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
    hasBackground: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: Object,
      default: () => ({}),
    },
    hasInnerBackground: {
      type: Boolean,
      default: false,
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    withSlider: {
      type: Boolean,
      default: false,
    },
    withoutSlider: {
      type: Boolean,
      default: false,
    },
    maxItems: {
      type: Number,
      default: 8,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showBackArrow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.bestpicks-h2 {
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 2px;
}
.market-subhead h3 {
  font-size: 16px;
  color: #717171;
}
.heading h3 {
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 0;
}
.heading {
  font-size: 21px;
  font-weight: 600;
  /* margin-top: 10px; */
}

.section-with-bg {
  padding-top: 10px;
  padding-bottom: 20px;
}

.section-logos {
  height: 195px;
}
.section-logos .container {
  /* padding-top: 0; */
}
.section-home-service {
  height: 413px;
  margin-bottom: 34px;
}
.slideItem {
  padding: 0;
}

.section-logos .v-slide-group {
  /* background-color: var(--secondary);
   */
  background: var(--secondaryLight);
  height: 160px;
  padding: 10px 27px 10px 27px;
  margin-top: 10px;
  border-radius: 12px;
}

.section-slider {
  height: 190px;
  z-index: 15;
}

.no-item {
  font-family: "roboto";
  font-weight: 800;
  font-size: 24px;
  padding: 80px;
}
.section-slider-head {
  margin: 10px 0px;
}

.section-slider-head button {
  /* width: 140px;
  height: 45px;
  background-color: var(--darkcolor);
  border: none; */
  color: #ff8a00;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
}

.section-slider-head button:hover {
  /* color: var(--darkcolor);
  background-color: var(--primarycolor); */
  cursor: pointer;
  /* background-color: var(--primarycolor); */
  /* font-weight: bold !important; */
}

.section-slider h1 {
  font-size: 26px;
  margin-bottom: 25px;
}

.section-slider > .v-slide-group {
  background-color: var(--secondary);
}

@media (max-width: 768px) {
  .slideItem {
    padding: 12px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .section-slider-head button {
    width: auto;
    height: auto;
    border: none;
  }
  .section-slider-head button:hover {
    color: var(--primarycolor);
    background-color: transparent;
  }
  .section-slider-head h1 {
    font-size: 18px;
    line-height: 18px;
    margin-bottom: 0;
  }
  .section-slider-head {
    margin-bottom: 12px;
  }
  .section-slider-head h3 {
    font-size: 1.3rem;
  }
  .section-logos .v-slide-group {
    margin-top: 0px;
    height: 120px;
    padding: 11px 17px 11px 17px;
  }
  .section-logos {
    height: 190px;
  }
}
/* Mobile responsiveness */
@media (max-width: 768px) {
  .section-slider-head {
    flex-direction: column;
    align-items: center;
  }
  .view-more-button {
    margin-top: 10px;
  }
  .bestpicks-h2 {
    text-align: center;
  }
  .heading {
    text-align: center;
  }
}
</style>
